import React, { Component } from 'react' ;
import Order from "../../../image/order.png";
import Profit from "../../../image/2.png";
import Earning from "../../../image/3.png";

export class DashboardThree extends Component {
  render() {
    return (
        <div className="container bg-none dashboard-three-main">
          <div className="row">
            <div className="col-6">
              <div className="container dashboard-three-first-sec">
                <div className="row">
                  <div className="col-12"><span className="dashboard-three-Title">Orders</span></div>
                  <div className="col-12"><h3 className="dashboard-three-heading">2,76K</h3></div>
                  <div className="col-12">
                  <img src={Order} alt="Not Found" className="dashboard-third-logo-sec" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
            <div className="container dashboard-three-second-sec">
            <div className="row">
                  <div className="col-12"><span className="dashboard-three-Title">Profit</span></div>
                  <div className="col-12"><h3 className="dashboard-three-heading">6,24K</h3></div>
                  <div className="col-12">
                  <img src={Profit} alt="Not Found" className="dashboard-third-logo-sec" />
                  </div>
                </div>
            </div>
            </div>
            <div className="col-12">
            <div className="container dashboard-three-third-sec">
              <div className="row">
                <div className="col-6">
                  <p className="dashboard-three-Title">Earnings</p>
                  <p className="dashboard-three-Thirdsec-thismonth">This Months<br /><span className="dashboard-three-Thirdsec-number">$405556</span></p>
                  <p className="dashboard-three-Third-footersec"><span>53% Grouth With Coustomer Satisfied</span></p>
                </div>
                <div className="col-6 d-flex">
                <img src={Earning} alt="Not Found" className="dashboard-third-third-logo-sec" />
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
    )
  }
}

export default DashboardThree ;